// extracted by mini-css-extract-plugin
export default {"PCBuild":"PCBuild_ccNVY","buildIcon":"buildIcon_AMhtd","buildTips":"buildTips_GGMNW","MobileBuild":"MobileBuild_H7sq9"};